import { UpsertPartnerQuoteInfoRequest } from "./upsert-partner-quote-info-request";

export type UpsertPartnerQuoteInfoWithQuoteOutcomeRequest = {
  lineOfBusiness: string;
  stateCode: string;
  emailId: string;
  firstName: string;
  lastName: string;
  zipCode: string;
  dateOfBirth: string;
  phoneNumber: string;
  referenceNumber: string;
  source: string;
  userType: string;
  agentId: string;
  agentName: string;
  premium: string;
  firstApplicationFormID: string;
  token: string;
  businessName: string;
  businessAddress: string;
  businessClassDescription: string;
  quoteUpdatedDate: string;
  quoteCreatedDate: string;
  agentNotes: string;
  disclosureNotes?: string;
  callReason: string;
  createdDate: string;
  correlationId?: string;
  quoteOutcome: QuoteOutcome;
};

export type QuoteOutcome = {
  quoteOutcomeType: string;
  primaryOutcomeType: string;
  secondaryOutcomeType: string;
  leadSource: string;
  language: string;
  policyNumber: string;
  effectiveDate: string;
  expirationDate: string;
  salesDate: string;
  soldPremium: string;
  paymentPlan: string;
  paymentConfirmationNumber: string;
  disclosuresRead: string[];
  disclosuresSelectedAsYes: string[];
  disclosuresSelectedAsNo: string[];
  disclosuresSelectedAsNA: string[];
  isEndorsement?: boolean;
  hasElectronicLoggingDevice?: boolean | null;
  telematicsProgramType?: string | null;
  telematicsSelection?: boolean | null;
};

const toTelematicsBoolean = (value?: string): boolean | null => {
  if (value === "yes") return true;
  if (value === "no") return false;
  return null;
};

export const convertToQuoteOutcomeRequest = (
  quoteInfo: UpsertPartnerQuoteInfoRequest
): UpsertPartnerQuoteInfoWithQuoteOutcomeRequest => {
  return {
    lineOfBusiness: quoteInfo.lineOfBusiness,
    stateCode: quoteInfo.stateCode,
    emailId: quoteInfo.emailId,
    firstName: quoteInfo.firstName,
    lastName: quoteInfo.lastName,
    zipCode: quoteInfo.zipCode,
    dateOfBirth: quoteInfo.dateOfBirth,
    phoneNumber: quoteInfo.phoneNumber,
    referenceNumber: quoteInfo.referenceNumber,
    source: quoteInfo.source,
    userType: quoteInfo.userType,
    agentId: quoteInfo.agentId,
    agentName: quoteInfo.agentName,
    premium: quoteInfo.premium,
    firstApplicationFormID: quoteInfo.firstApplicationFormID,
    token: quoteInfo.token,
    businessName: quoteInfo.businessName,
    businessAddress: quoteInfo.businessAddress,
    businessClassDescription: quoteInfo.businessClassDescription,
    quoteUpdatedDate: quoteInfo.quoteUpdatedDate,
    quoteCreatedDate: quoteInfo.quoteCreatedDate,
    agentNotes: quoteInfo.agentNotes,
    disclosureNotes: quoteInfo.disclosureNotes,
    callReason: quoteInfo.callReason,
    createdDate: quoteInfo.createdDate,
    correlationId: quoteInfo.correlationId,
    quoteOutcome: {
      quoteOutcomeType: quoteInfo.quoteOutcome,
      primaryOutcomeType: quoteInfo.primaryOutcomeType,
      secondaryOutcomeType: quoteInfo.secondaryOutcomeType,
      leadSource: quoteInfo.leadSource,
      language: quoteInfo.language,
      policyNumber: quoteInfo.policyNumber,
      effectiveDate: quoteInfo.effectiveDate,
      expirationDate: quoteInfo.expirationDate,
      salesDate: quoteInfo.salesDate,
      soldPremium: quoteInfo.soldPremium,
      paymentPlan: quoteInfo.paymentPlan,
      paymentConfirmationNumber: quoteInfo.paymentConfirmationNumber,
      disclosuresRead: quoteInfo.disclosuresRead,
      disclosuresSelectedAsYes: quoteInfo.disclosuresSelectedAsYes,
      disclosuresSelectedAsNo: quoteInfo.disclosuresSelectedAsNo,
      disclosuresSelectedAsNA: quoteInfo.disclosuresSelectedAsNA,
      isEndorsement: quoteInfo.isEndorsement,
      hasElectronicLoggingDevice: toTelematicsBoolean(quoteInfo.hasElectronicLoggingDevice),
      telematicsProgramType: quoteInfo.telematicsProgramType ?? null,
      telematicsSelection: toTelematicsBoolean(quoteInfo.telematicsSelection),
    },
  };
};

export const defaultQuoteOutcomeHighlightMap: Record<string, boolean> = {
  'quoteOutcome': false,
  'primaryOutcomeType': false,
  'secondaryOutcomeType': false,
  'zipCode': false,
  'stateCode': false,
  'emailId': false,
  'phoneNumber': false,
  'firstName': false,
  'lastName': false,
  'dateOfBirth': false,
  'referenceNumber': false,
  'source': false,
  'lineOfBusiness': false,
  'effectiveDate': false,
  'expirationDate': false,
  'premium': false,
  'paymentPlan': false,
  'paymentConfirmationNumber': false,
  'leadSource': false,
  'language': false,
  'businessName': false,
  'businessAddress': false,
  'businessClassDescription': false,
} 
